/* eslint-disable no-undef */
import { Post } from '@app/types/core';
import push from '../../utils/routing';

export const goToPost =
  ({ classRoom, objectId }: Partial<Post>) =>
  () =>
    push(`/dashboard/${classRoom}/community/post/${objectId}`);
